import Axios from "axios";

import store from "../store";
import { handleLoginFailure } from "@/utils";
import { VUE_APP_API_URL, VUE_APP_API_OUT_URL } from "@/config";
// import cookie from "@/utils/cookie";
import { LOGIN_TOKEN_KEY } from "@/utils/constants";
import router from "@/router";

const requestInstance = Axios.create({
  baseURL: VUE_APP_API_URL, // 从环境变量读取基础URL
  timeout: 10000, // 请求超时时间
});

requestInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error("REQUEST FAIL", error);
    const response = error && error.response ? error.response : null;
    const responseData = response && response.data ? response.data : null;
    if (error.toString() == "Error: Network Error") {
      console.log("————————");
      console.log("请求失败", error);
      console.log("————————");
      // handleLoginFailure();
      return Promise.reject({ msg: "未登录", toLogin: true });
    }
    if (response && response.status == 401) {
      console.log("————————");
      console.log("登录失效 401", error);
      console.log("————————");
      handleLoginFailure();
      return Promise.reject({ msg: "未登录", toLogin: true });
    }
    if (responseData && responseData.status == 5109) {
      // uni.showToast({
      //     title: error.response.data.msg,
      //     icon: "none",
      //     duration: 2000,
      // });
    }
    return Promise.reject(error);
  }
);
const defaultOpt = { login: true };

function baseRequest(options) {
  // 从缓存中获取 token 防止 token 失效后还会继续请求的情况
  const token = localStorage.getItem(LOGIN_TOKEN_KEY);

  // 合并传参过来的 headers
  // 如果接口需要登录，携带 token 去请求
  // console.log('REQUEST OPTION', options, requestInstance);
  if (options.out) {
    requestInstance.defaults.baseURL = VUE_APP_API_OUT_URL;
  } else {
    requestInstance.defaults.baseURL = VUE_APP_API_URL;
  }

  options.headers = {
    ...options.headers,
  };

  if (options.login === true) {
    if (token && token != "") {
      Object.assign(options.headers, { Authorization: "Bearer " + token });
    }
    // options.headers = {
    //     ...options.headers,
    //     Authorization: "Bearer " + token,
    // };
  }

  // 结构请求需要的参数
  const { url, params, data, login, ...option } = options;

  // 发起请求
  return (
    requestInstance
      // .request(url, params || data, {
      //     ...option,
      // })
      .request(options)
      .then((res) => {
        if ([200, 201].indexOf(res.status) < 0) {
          return Promise.reject({ msg: "请求失败", res, data });
        }
        const data = res.data || {};
        // 适配特殊情况
        if (data.errno == 0) {
          return Promise.resolve(data, res);
        }

        if (data.success === true || data.code === "SUCCESS") {
          return Promise.resolve(data, res);
        }

        if ([401, 403].indexOf(data.status) !== -1) {
          handleLoginFailure();
          if (window.location.href.includes("/home")) {
            return Promise.reject({ msg: res.data.msg, data: res.data });
          }
        } else if (data.status === 200) {
          return Promise.resolve(data, res);
        } else if (data.status == 5101) {
          return Promise.reject({ msg: res.data.msg });
        } else if ([5106, 5107].indexOf(data.status) >= 0) {
          if (window.location.href.includes("/home")) {
            return Promise.reject({ msg: res.data.msg, data: res.data });
          } else {
            // handleLoginFailure();
            router.push("/home");
          }
        } else {
          return Promise.reject({ msg: res.data.msg });
        }
      })
      .catch((err) => {
        console.log("请求报错", err);
        let errData = {};
        if (err.data) {
          errData = err.data;
        }
        return Promise.reject({ msg: err.msg || err.message, data: errData });
      })
  );
}

/**
 * http 请求基础类
 * 参考文档 https://www.kancloud.cn/yunye/axios/234845
 *
 */
const request = ["post", "put", "patch"].reduce((request, method) => {
  /**
   *
   * @param url string 接口地址
   * @param data object get参数
   * @param options object axios 配置项
   * @returns {AxiosPromise}
   */
  request[method] = (url, data = {}, options = {}) => {
    return baseRequest(Object.assign({ url, data, method }, defaultOpt, options));
  };
  return request;
}, {});

["get", "delete", "head"].forEach((method) => {
  /**
   *
   * @param url string 接口地址
   * @param params object get参数
   * @param options object axios 配置项
   * @returns {AxiosPromise}
   */
  request[method] = (url, params = {}, options = {}) => {
    return baseRequest(Object.assign({ url, params, method }, defaultOpt, options));
  };
});

export default request;
